module.exports = __webpack_public_path__ + "static/img/floor2-img.5f4b6e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor2-img.png
// module id = 4BUs
// module chunks = 1